import './contact-view-mail-layout.component.ajs.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IEpticaExctractEvent } from '@commons/history/history-mail/models/eptica-extract';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { isArray } from 'jquery';
import { throwIfEmpty, withLatestFrom } from 'rxjs';

import {
  EpticaService,
  extractEpticaField,
  firstOfArr,
  isNotNullOrUndefined,
  Memo,
  ProfileFacade,
  RequestId,
  reverseOfArr,
  splitOfStr,
} from '@contact/upgrade';

import { MailLayoutOptions, MailWorkspaceConfigurationService } from '../../mail-workspace-configuration.service';
import { AgentBookinMailInprocessState } from '../agent-booking-mail-routing.module';
import templateUrl from './contact-view-mail-layout.component.ajs.html';

const MODULE_NAME = 'contactViewMailLayout';

class ContactViewMailLayoutCtrl implements IComponentController {
  public name = MODULE_NAME;

  memo: Memo;
  responseId: string;
  ready = false;
  epticaEvents: IEpticaExctractEvent[];
  isCurrentAgentBlindAskForHelpTargeted = false;
  layoutOptions: MailLayoutOptions;
  private state: string;
  open = true;

  constructor(
    private readonly $transcule: any,
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly profileFacade: ProfileFacade,
    private readonly epticaService: EpticaService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly mailWorkspaceConfigurationService: MailWorkspaceConfigurationService,
    private readonly router: AgentDesktopRouter
  ) {}

  $onInit(): void {
    this.router.currentUrl$
      .pipe(isNotNullOrUndefined(), splitOfStr('/'), reverseOfArr(), firstOfArr(), isNotNullOrUndefined(), ng1Destroy(this))
      .subscribe(state => (this.state = state));
    this.layoutOptions = this.mailWorkspaceConfigurationService.getLayoutOptions();
    this.contactDeprecatedService
      .getSelectedContact()
      .then(contact => {
        this.memo = contact.mailMemo ?? {
          message: '',
          date: '',
        };
        this.compareBlindOptionTargetWithCurrentAgent(contact.epticaRequestId ?? 0);
        return this.epticaDeprecatedService.loadRequest({
          requestId: contact.epticaRequestId ?? 0,
          responseId: this.responseId,
          lazy: true,
        });
      })
      .then(request => {
        this.ready = true;
        request
          .retrieveConversationalEvents()
          .pipe(ng1Destroy(this))
          .subscribe(events => (this.epticaEvents = events));
      });
  }

  getControlledHistoryEvents() {
    const active = this.state === AgentBookinMailInprocessState.answerAskForHelp;
    return active && this.isCurrentAgentBlindAskForHelpTargeted ? [] : this.epticaEvents;
  }

  compareBlindOptionTargetWithCurrentAgent(requestId: RequestId) {
    this.epticaService
      .getRequest(requestId)
      .pipe(isNotNullOrUndefined(), throwIfEmpty(), withLatestFrom(this.profileFacade.id$), ng1Destroy(this))
      .subscribe(([request, id]) => {
        const blindInfoStr = extractEpticaField(request, 'wlBlindAskHelp');
        const blindInfos = blindInfoStr && blindInfoStr !== 'none' ? JSON.parse(blindInfoStr) : [];
        if (isArray(blindInfos) && blindInfos.length > 0) {
          this.isCurrentAgentBlindAskForHelpTargeted = blindInfos.some(info => info.uuid && info.uuid === id && info.blind);
        }
      });
  }

  isInTransferOrAssistanceState(): boolean {
    const forward = this.state === AgentBookinMailInprocessState.forward;
    const askForHelp = this.state === AgentBookinMailInprocessState.askForHelp;
    return forward || askForHelp;
  }

  hasTransclude(transcludeName: string) {
    return this.$transcule.isSlotFilled(transcludeName);
  }
}

export class ContactViewMailLayout implements IComponentOptions {
  templateUrl = templateUrl;
  transclude = {
    actionsRef: '?actionsRef',
    expandRef: '?expandRef',
    coreHeaderRef: '?coreHeaderRef',
    coreRef: '?coreRef',
  };
  bindings = {
    responseId: '<',
  };
  controller = [
    '$transclude',
    'epticaDeprecatedService',
    'profileFacade',
    'epticaService',
    'contactDeprecatedService',
    'mailWorkspaceConfigurationService',
    'agentDesktopRouter',
    ContactViewMailLayoutCtrl,
  ];
}

export default MODULE_NAME;
